import * as CryptoJS from 'crypto-js';

// Encrypts a string using DES with a key
export function encryptDES(message: string, passPhrase: string): string {
  try {
    // Step 1: Compute the MD5 hash of the passPhrase.
    // CryptoJS.MD5() implicitly converts the passPhrase to a UTF-8 word array.
    const key = CryptoJS.MD5(passPhrase);

    // Step 2: Encrypt the message using TripleDES in ECB mode with PKCS7 padding.
    // The input message is automatically converted to the internal format.
    const encrypted = CryptoJS.TripleDES.encrypt(message, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    // Step 3: Return the encrypted data as a Base64 encoded string.
    return encrypted.toString();
  } catch (error) {
    console.error('Encryption failed:', error);
    return '';
  }
}

// Decrypts a string using DES with a key
export function decryptDES(encryptedMessage: string, passPhrase: string): string {
   // Step 1: Hash passphrase with MD5
   const md5Hash = CryptoJS.MD5(passPhrase);

   // Step 2: Decrypt the message using TripleDES in ECB mode with PKCS7 padding
   const decrypted = CryptoJS.TripleDES.decrypt(
     encryptedMessage,
     md5Hash,
     {
       mode: CryptoJS.mode.ECB,
       padding: CryptoJS.pad.Pkcs7
     }
   );

   // Convert decrypted data back to Utf8 string
   return decrypted.toString(CryptoJS.enc.Utf8);
}
